<div class="col-12 nex-steps-3" [ngClass]="{'nex-steps-4': hasSignature, 'nex-steps-3': !hasSignature}">
  <p-steps [model]="process" [(activeIndex)]="activeIndex"></p-steps>
</div>
<div class="col-12">
  <div class="col-4 align-left">
  </div>
  <div class="col-4 align-center">
  </div>
  <div class="col-4 align-right">
    <button *ngIf="currentStep === 'REVIEW'" type="button" [icon]="'fa fa-check'" class="p-button-warning"
            [iconPos]="'right'"
            [label]="'COMMON.VALIDATE' | translate" pButton (click)="saveExpressDeposit()"></button>
  </div>
</div>
<div class="col-12" *ngIf="currentStep === 'PARAMS'">
  <app-deposit-options [depositType]="DepositDepotExpressEnum.UNIT" (moveNext)="nextStep()" (signatureChange)="setSignatureFile($event)"
                       (depositDirChange)="setDepositDir($event)"></app-deposit-options>
</div>
<div class="col-12" *ngIf="currentStep === 'TEMPLATE'">
  <div class="col-12 align-right">
    <button [disabled]="!nextEnabled()" type="button" [icon]="'fa fa-hand-o-right'"
            [label]="'COMMON.NEXT' | translate" pButton (click)="nextStep()"></button>
  </div>
  <div class="col-3">
    <!--<div class="col-12">
      <app-files-upload
        filesTitle=""
        [moreThanOneFile]="false"
        [acceptedFiles]="['pdf']"
        [optional]="false"
        [shouldClearFiles]="shouldClearFiles"
        (isValid)="updateUploadValidity(FileStatus.MAIN, $event)"
        (selectedFiles)="setMainFile(FileStatus.MAIN, $event)">
      </app-files-upload>
    </div>-->
<!--    <div class="col-12">
      <div class="template-type-option" [ngClass]="{'template-selected': templateSource === 'USER_PDF'}">
        <p-radioButton name="templateSource" value="USER_PDF" (onClick)="showModelBrowser()"
                       [label]="'UPLOAD_COMPONENT.MAIN_FILE_SELECTION' | translate"
                       inputId="depopt1"></p-radioButton>
      </div>
    </div>-->
    <!--<div class="col-12">
      <div class="template-type-option" [ngClass]="{'template-selected': templateSource === 'LOOL_ODT'}">
        <p-radioButton name="templateSource" value="LOOL_ODT" (onClick)="openEditor()"
                       [label]="'UPLOAD_COMPONENT.MAIN_FILE_CREATION' | translate"
                       inputId="depopt2"></p-radioButton>
      </div>
    </div>-->

    <!--<p-fieldset [legend]="'UPLOAD_COMPONENT.MAIN_FILE_SELECTION' | translate">-->
    <div class="col-12" *ngIf="templateSource === 'USER_PDF'">
      <app-files-upload
        [filesTitle]="'UPLOAD_COMPONENT.MAIN_FILE_SELECTION' | translate"
        [moreThanOneFile]="false"
        [acceptedFiles]="acceptedUtinFiles"
        [optional]="false"
        [shouldClearFiles]="shouldClearFiles"
        (isValid)="updateUploadValidity(FileStatus.MAIN,$event)"
        (selectedFiles)="setMainFile(FileStatus.MAIN,$event)">
      </app-files-upload>
    </div>
    <!--    <div class="col-12">
          <button pButton type="button" [label]="'COMMON.EXTRACT' | translate" class="p-button-success"
                  (click)="extractRegion()"></button>
        </div>-->
    <p-fieldset [legend]="'UPLOAD_COMPONENT.ADDRESS_CAPTURE_RESULT' | translate"
                *ngIf="pagesImages && pagesImages.hasOwnProperty('page_1')">
      <div class="col-12 extract-region-result">
        <div class="col-12"
             *ngIf="(!extractedAddress || !extractedAddress.isValid()) && resultItems && resultItems.length >0">
          <div class="col-12" *ngFor="let item of resultItems">
            {{item}}
          </div>
        </div>
        <div class="col-12"
             *ngIf="extractedAddress && extractedAddress.isValid() && extractedAddress && extractedAddress.formatted && extractedAddress.formatted.length >0">
          <div class="col-12" *ngFor="let item of extractedAddress.formatted">
            <ng-container *ngIf="item.toUpperCase() !== 'FRANCE'">{{item}}</ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="col-6" *ngIf="extractedAddress && extractedAddress.isValid()"
               style="font-size: 1.3em; color: #107D11">{{'COMMON.ADDRESS_IS_VALID'|translate}}</div>
          <div class="col-6" *ngIf="!extractedAddress || !extractedAddress.isValid()"
               style="font-size: 1.3em; color: #e71808">{{'COMMON.ADDRESS_IS_NOT_VALID'|translate}}
          </div>
          <div class="col-12">
            <button *ngIf="!extractedAddress || !extractedAddress.isValid()" pButton type="button"
                    [label]="'COMMON.CORRECT_ADDRESS' | translate" class="p-button-success"
                    (click)="editUnitAddress()"></button>
            <button *ngIf="extractedAddress && extractedAddress.isValid()" pButton type="button"
                    [label]="'COMMON.MODIFY_ADDRESS' | translate" class="p-button-success"
                    (click)="editUnitAddress()"></button>
          </div>
        </div>
      </div>
    </p-fieldset>
  </div>
  <div class="col-9">
    <div class="col-12" *ngIf="mainFile">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.ADDRESS_DOC_CAPTURE' | translate"
                  *ngIf="pagesImages && pagesImages.hasOwnProperty('page_1')">
        <div class="col-12" *ngIf="pageCount > 1">
          <p-paginator [rows]="1" [totalRecords]="pageCount" (onPageChange)="updateBG($event)"
                       [showCurrentPageReport]="true"
                       [currentPageReportTemplate]="'Page:  {currentPage} sur {totalPages}'"></p-paginator>
        </div>
        <div class="col-12">
          <div class="extract-region-container" #addressDragContainer>
            <div class="extract-region-bg" [ngStyle]="containerBGStyle">
              <!--<div class="omr left-omr"></div>
              <div class="omr right-omr"></div>-->
              <div class="extract-region-rect" #addressTargetContainer [ngStyle]="targetContainerStyle"
                   ngResizable="true"
                   ngDraggable="true"
                   [rzHandles]="'n,e,s,w,se,sw,ne,nw'"
                   (endOffset)="recalculateRegion()"
                   (rzStop)="recalculateRegion()"
                   [bounds]="addressDragContainer"
                   rzContainment="#addressDragContainer"
                   [inBounds]="true"
              ></div>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
  </div>
</div>
<div class="col-12" *ngIf="currentStep === 'FORMATTING'">
  <app-signature-options [signature]="signature" [depositDir]="depositDir" [pagesImages]="pagesImages"
                         [pageCount]="pageCount" [pages]="pages"
                         [sigPages]="sigPages"
                         (stored)="signaturePositionStored($event)"></app-signature-options>
</div>
<div class="col-12" *ngIf="currentStep === 'REVIEW'">
 <app-deposit-review type="UNIT" [foldCount]="1" [depositDir]="depositDir" [customizedFilePdf]="customizedFilePdf"></app-deposit-review>
  <!-- <div class="col-3">
    <div class="col-12">
      <button type="button" [icon]="'fa fa-search'"
              [label]="'UPLOAD_COMPONENT.DOWNLOAD_FINAL' | translate" pButton
              (click)="loadVisualization(true)"></button>
    </div>
  </div>
  <div class="col-6 viewer-container">
    <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl"
            type="application/pdf" width="100%"
            height="100%"></object>
  </div>
  <div class="col-3"></div>-->
</div>
<div *ngIf="showEditAddress">
  <p-dialog [styleClass]="'express-address-dialog'" [appendTo]="'body'" [(visible)]="showEditAddress"
            [header]="'Je saisie l\'adresse du destintaire de mon courrier '"
            [draggable]="true"
            [focusTrap]="false"
            [modal]="true">
    <app-express-address (finalAddress)="updateUnitAddress($event)"
                         (visible)="handleDestAddressClose()"
                         [objAddress]="addressToEdit"
                         [lines]="addressToEditLines"></app-express-address>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>
<div class="saving-loader-modal">
  <p-dialog [appendTo]="'body'" [(visible)]="displayLoading" [header]="'UPLOAD_COMPONENT.LOADER_TITLE' | translate"
            id="ex-save-loader" [draggable]="false" [closable]="false" [resizable]="false"
            [modal]="true" [closeOnEscape]="false">
    <div class="center">
      <div class="col-12" *ngIf="savingTrial && savingTrial > 1">
        <p>{{'UPLOAD_COMPONENT.SAVE_DEPOSIT_TRIAL' | translate}}: {{savingTrial}}</p>
      </div>
      <p *ngIf="depositPersistedSerialLot">{{'UPLOAD_COMPONENT.STATUS_SERIAL_DEPOSIT' | translate}}
        : {{depositPersistedSerialLot}}</p>
      <p-progressBar [value]="progressPersisted"></p-progressBar>
      <div class="col-12" *ngIf="depositPersistedSerialLot">
        <button pButton type="button" (click)="closeLoader()" [label]="'COMMON.CLOSE' | translate"
                class="p-button-danger"></button>
      </div>
      <p></p>
      <p>{{'UPLOAD_COMPONENT.LOADER_HINT' | translate}}</p>
    </div>
  </p-dialog>
</div>
<div *ngIf="openVisualization">
  <p-dialog [styleClass]="'file-display-dialog'" [appendTo]="'body'" [(visible)]="openVisualization"
            [header]="'Je vérifie mon courrier avant de le soumettre '" (onHide)="freeDocMemory(pdfToDisplay)"
            [draggable]="true"
            [closable]="true"
            [maximizable]="true"
            [modal]="true" [closeOnEscape]="true">
    <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl"
            type="application/pdf" width="100%"
            height="100%"></object>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>
<div *ngIf="showMailingModelEditor">
  <p-dialog [styleClass]="'edit-unit-model-editor-dialog'" [appendTo]="'body'" [(visible)]="showMailingModelEditor"
            [header]="'Je crée un nouveau modèle de courrier '"
            [draggable]="false"
            [closable]="true"
            [maximizable]="false"
            [modal]="true" [closeOnEscape]="true" (close)="editorClosed()">
    <app-mailing-model-editor [draggableColumns]="[]" [loolLink]="externalLink"
                              (closeDialogue)="closeEditor()"></app-mailing-model-editor>
  </p-dialog>
</div>
